<nav class="navbar navbar-default">
    <div class="container-fluid">
        <div class="navbar-header">
            <button type="button" class="navbar-toggle" data-toggle="collapse" (click)="sidebarToggle()">
                <span class="sr-only">Toggle navigation</span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
            </button>
            <!--<a class="navbar-brand">{{getTitle()}}</a>-->
            <!--<div *ngIf="availableModes.length > 1" class="selectMode">-->
                <!--<select #mode (change)="changeMode(mode.value)" class="btn btn-secondary dropdown-toggle modeSelector">
                    <option *ngFor="let mode of availableModes" [selected]="_Globals.getMode() == mode" [value]="mode">{{mode}}</option>
                </select>-->
                    <!--<option [selected]="_Globals.getMode() == 'Administrator'" value="admin">Administrator</option>
                    <option [selected]="_Globals.getMode() == 'Coach'" value="coach">Coach</option>
                    <option [selected]="_Globals.getMode() == 'Client'" value="client">Client</option>-->
                    <!--<option [selected]="_Globals.getMode() == 'Rater'" value="rater">Rater 360</option>-->
                <!--<select #langSelect class="btn btn-secondary dropdown-toggle modeSelector" (change)="translate.use(langSelect.value)">
                    <option *ngFor="let lang of translate.getLangs()" [value]="lang" [selected]="lang === translate.currentLang">{{ lang }}</option>
                </select>-->
            <!--</div>-->
        </div>

        <div class="collapse navbar-collapse">
            <div class="navbar-right-menu">

                <div class="avatar-name">
                    <!--<span title="{{_Globals.getFullName()}}">{{_Globals.getFullName()}}</span>-->
                </div>

                <div #userImage (click)="showUserMenu = !showUserMenu;" class="avartar-wrap">
                    <!--<img class="avatar-logo" src="../../../assets/img/default-avatar.png" alt="Alternate Text" />-->
                    <!--<div class="avatar-logo" title="{{_Globals.getFullName()}}" style="background-color: #259bbf;color: white;border-radius: 50%;width: 40px;height: 40px;">
                        <span style="position: relative;top: 10px;left: 15px;">{{_Globals.getFullName()[0]}}</span>
                    </div>-->
                    <div (click)="toggleUserMenu()" title="{{_Globals.getFullName()}}" class="badge badge-blue">{{_Globals.getFullName()[0]}}</div>
                </div>

                <div #userMenu class="user-menu" [ngClass]="{'visible': showUserMenu, 'notVisible': !showUserMenu}">
                    <div class="container-fluid">
                        <p class="">{{_Globals.getFullName()}}</p>
                    </div>
                    <hr style="margin: 0 0 10px;" />
                    
                    <div *ngIf="_Globals.hasBetaAccess()" class="selectMode">
                        <div class="container-fluid">
                            <select id="environmentSelect" #environment (change)="changeEnvironment(environment.value)" class="btn-secondary dropdown-toggle modeSelector">
                                <option *ngFor="let environment of availableEnvironments" [selected]="_Globals.getEnvironment() == environment.value" [value]="environment.value">{{environment.label}}</option>
                            </select>
                        </div>
                        <hr style="margin: 0 0 10px;" />
                    </div>
                    <div *ngIf="availableModes.length > 1" class="selectMode">
                        <div class="container-fluid">
                            <select id="customSelectId" #mode (change)="changeMode(mode.value)" class="btn-secondary dropdown-toggle modeSelector">
                                <option *ngFor="let mode of availableModes" [selected]="_Globals.getMode() == mode" [value]="mode">{{mode}}</option>
                            </select>
                        </div>
                        <hr style="margin: 0 0 10px;" />
                    </div>
                    <div class="container-fluid">
                        <a *ngIf="_Globals.getMode() == 'Coach'" [routerLink]="['/app/profile']" style="">
                            <i style="font-size: 30px;" class="pe-7s-user"></i>
                            <span style="vertical-align: super;">Profile</span>
                        </a>
                    </div>

                    <div class="container-fluid">
                        <a *ngIf="_Globals.getMode() == 'Client'" [routerLink]="['/app/client_profile']" style="">
                            <i style="font-size: 30px;" class="pe-7s-user"></i>
                            <span style="vertical-align: super;">Profile</span>
                        </a>
                    </div>

                    <div class="container-fluid logout">
                        <a (click)="logout()" class="dropdown-item" data-toggle="modal" data-target="#logoutModal" style="">
                            <!--<i class="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400" style="margin-right: 4px;padding: 0px 6px;font-size: 21px;"></i>-->
                            <i style="transform: rotate(90deg); font-size: 30px;" class="pe-7s-upload"></i>
                            <span style="vertical-align: super;">Logout</span>
                        </a>
                    </div>


                </div>
            </div>

        </div>

        <div class="responsive-user-menu">
            <!--<i (click)="toggleUserMenu()" class="large  material-icons">person</i>-->
            <!--<div (click)="toggleUserMenu()" class="avatar-logo" title="{{_Globals.getFullName()}}" style="background-color: #259bbf;color: #fff;border-radius: 50%;width: 37px;height: 37px;">
                <span style="position: relative;top: 9px;left: 14px;">{{_Globals.getFullName()[0]}}</span>
            </div>-->
            <div (click)="toggleUserMenu()" class="badge badge-blue">{{_Globals.getFullName()[0]}}</div>
        </div>


    </div>
</nav>